import React from 'react';
import { Grid, IconButton, Typography, makeStyles } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
var useStyles = makeStyles(function (theme) {
  return {
    header: {
      padding: theme.spacing(1.5, 2, 0),
      width: 268
    },
    arrow: {
      padding: 4
    }
  };
});

var CalendarHeader = function CalendarHeader(_a) {
  var month = _a.month,
      onChange = _a.onChange;
  var classes = useStyles();
  return React.createElement(Grid, {
    container: true,
    className: classes.header
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "small",
    onClick: function onClick() {
      return onChange(month.clone().subtract(1, 'month'));
    }
  }, React.createElement(ArrowBackIcon, {
    className: classes.arrow,
    fontSize: "small"
  }))), React.createElement(Grid, {
    container: true,
    item: true,
    xs: true,
    justify: "center",
    alignItems: "center"
  }, React.createElement(Typography, {
    variant: "body2"
  }, month.format('MMMM YYYY'))), React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    size: "small",
    onClick: function onClick() {
      return onChange(month.clone().add(1, 'month'));
    }
  }, React.createElement(ArrowForwardIcon, {
    fontSize: "small"
  }))));
};

export default CalendarHeader;